<template>
	<view class="box">
		<view class="box_head">
			<text>华晟智慧园区</text>
			<text class="h2">安全重于泰山 服务追求卓越</text>
			<image mode="widthFix" class="banner_bg" src="@/static/banner.jpg" />
		</view>
		<view class="main_title">业务办理</view>
		<view class="box_list">
			<view class="box_list_item" @click="jump(1)">
				<image src="@/static/ic_laifangdengji.png" mode="widthFix" />
			</view>
			<view class="box_list_item" @click="jump(2)">
				<image src="@/static/ic_yuyuejilu.png" mode="widthFix" />
			</view>
			<view class="box_list_item" @click="jump(3)">
				<image src="@/static/ic_yuanqudaolan.png" mode="widthFix" />
			</view>
			<view class="box_list_item" @click="jump(4)">
				<image src="@/static/ic_yuyuezhinan.png" mode="widthFix" />
			</view>
		</view>
		<!-- <view class="box_btn">退出登录</view> -->
		<view class="copyright">
			<image src="@/static/logo_s@2x.png" mode="widthFix" />
			<text>安徽安泰物流有限责任公司版权所有</text>
		</view>
	</view>
</template>

<script>
import image from 'uview-ui/libs/config/props/image'

	export default {

		data() {
			return {

			}
		},

		methods: {
			jump(type) {
				switch (type) {
					case 1:
						uni.navigateTo({
							url: '/pages/notice/notice'
						})
						break
					case 2:
						uni.navigateTo({
							url: '/pages/applicationRecord/applicationRecord'
						})
						break
					case 3:
						uni.navigateTo({
							url: '/pages/personnel/personnel'
						})
						break
					case 4:
						uni.navigateTo({
							url: '/pages/visitorSubGuide/index'
						})
						break
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.box {
		width: 100%;
		height: auto;
		padding: 30rpx;
		box-sizing: border-box;

		.box_btn {
			position: fixed;
			bottom: 70rpx;
			left: 50%;
			transform: translate(-50%, 0);
			width: 208rpx;
			height: 72rpx;
			line-height: 72rpx;
			text-align: center;
			border-radius: 36rpx;
			border: 1rpx solid #999999;
			font-size: 28rpx;
			font-weight: 400;
			color: #333333;
		}

		.box_head {
			width: 100%;
			height: 270rpx;
			padding: 0 44rpx;
			box-sizing: border-box;
			border-radius: 8rpx;
			display: flex;
			flex-direction: column;
			position: relative;
			.banner_bg{
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				z-index: -1;
			}
			.h2 {
				font-size: 28rpx;
				font-family: SourceHanSansSC, SourceHanSansSC;
				font-weight: 400;
				color: #FFFFFF;
				margin-top: 14rpx;
			}
			text {
				&:first-child {
					font-size: 44rpx;
					font-family: SourceHanSansSC, SourceHanSansSC;
					font-weight: bold;
					color: #FFFFFF;
					margin-top: 54rpx;
				}
			}
		}
		.main_title{
			font-weight: 500;
			font-size: 32rpx;
			color: #222222;
			margin: 40rpx 0 32rpx;
		}
		.box_list {
			width: 100%;
			display: flex;
			align-items: center;
			flex-wrap: wrap;
			justify-content: space-between;
			margin-top: 40rpx;

			.box_list_item {
				width: 100%;
				margin-bottom: 20rpx;
				image {
					width: 100%;
				}
			}
		}
		.copyright{
			display: flex;
			align-items: center;
			justify-content: center;
			margin-top: 84rpx;
			font-size: 24rpx;
			color: #666666;
			image{
				width: 40rpx;
				height: 40rpx;
			}
		}
	}
</style>